import React from "react"

const Copywright = () => (
  <div className="my2 caption max-width-5 mx-auto">
    &copy; CineSend {new Date().getFullYear()}. All Rights Reserved.
  </div>
)

export default Copywright
